<template>
  <el-empty v-if="disabled" :description="$t('siteBuild.noActivity')" class="relative" />
  <div v-else class="consecutive-col-body" :style="getStyle"
    :class="[$store.getters.isMobile && 'is-mobile', bodyClassName]">
    <div ref="content" class="group-list relative">
      <div v-for="(group, index) in groupList" :key="index + 'group'" class="list">
        <div v-for="(item, childIndex) in group" :key="childIndex + 'group-item'" :ref="`item-${item.day_no}`"
          :class="{ 'is-active': item.active }" class="item">
          <template v-if="item.day_no">
            <bg-style :bg="model.cardBackground" class="w-full card" :radius="model.cardRadius"
              @click.native.stop="handleItemClick(item)">
              <bg-style :bg="model.logoBackground" class="thumb relative">
                <img :src="model.detailVisible ? (item.cover || item.thumb) : item.thumb" alt="" class="relative" />
                <div v-if="!model.detailVisible" class="thumb-number">
                  X{{ item?.gift_list?.[0]?.num }}
                </div>
              </bg-style>
              <div class="info-area relative">
                <div v-if="model.detailVisible" class="mx-auto w-full overflow-auto">
                  <div class="gifts gap-2">
                    <div v-for="(gift, giftIndex) in item.gift_list" :key="giftIndex"
                      class="pack flex items-center flex-shrink-0 font-bold">
                      <img :src="gift.gift_goods_logo" alt="" class="icon" />
                      <i class="el-icon-close font-bold" />
                      <span>{{ gift.num }}</span>
                    </div>
                  </div>
                </div>
                <bg-style v-if="item.get_status === 1" :bg="model.disabledBackground" :radius="model.cardRadius"
                  class="handle" @click.native.stop>
                  <span class="relative disabled-text">{{ $t('siteBuild.activity.haveGet') }}</span>
                </bg-style>
                <bg-style v-if="item.get_status === 2" :bg="model.getBackground" :radius="model.cardRadius"
                  class="handle" @click.native.stop="handlePick(item)">
                  <span class="relative get-text">{{ $t('siteBuild.activity.get') }}</span>
                </bg-style>
                <bg-style v-if="item.get_status === 3" :bg="model.disabledBackground" :radius="model.cardRadius"
                  class="handle" @click.native.stop>
                  <span class="relative disabled-text">{{ $t('siteBuild.activity.notQualified')
                  }}</span>
                </bg-style>
              </div>
            </bg-style>
            <div class="circle z-10 relative" />
            <div class="number">Day {{ item.day_no }}</div>
          </template>
        </div>
        <bg-style :bg="model.progressBackground" class="progress">
          <bg-style :bg="model.innerBackground" :style="{ width: progressWidthMap[index] || 0 }"
            class="inner relative h-full" />
        </bg-style>
      </div>
    </div>
    <info-detail ref="info" :data="currentRow" :is-mobile="isMobile" />
  </div>
</template>

<script>
import { Empty } from "element-ui"
import InfoDetail from './info.vue'
import consecutiveMixins from "~/mixins/consecutiveMixins"
import Bus from '~/site/model/bus'
import { sleep } from "~/utils"

export default {
  name: 'ConsecutiveColContent',
  components: {
    InfoDetail,
    [Empty.name]: Empty
  },
  mixins: [consecutiveMixins],
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      disabled: false,
      currentRow: {}
    }
  },
  watch: {
    async isMobile() {
      await sleep(500)
      this.initLayout()
    },
    cardSizeType() {
      this.initLayout()
    },
    bizId(n, o) {
      if (n !== o) this.init()
    }
  },
  mounted() {
    this.init()
    Bus.$on('reloadActivity', () => {
      this.init()
    })
  },
  methods: {
    initLayout() {
      this.getGroupList()
      this.$nextTick(() => { this.renderProgress() })
    },
    async init() {
      await this.getActivityData()
      await this.locationAvailableItem()
    },
    handleItemClick(data) {
      if (this.editing) return
      this.currentRow = data
      this.$refs.info.init()
    }
  }
}
</script>

<style lang="less">
.consecutive-col-body {
  --list-gap: 16.5px;

  .group-list {
    overflow: auto;

    &::-webkit-scrollbar {
      height: 0;
      display: none;
    }
  }

  .list {
    width: max-content;
    display: flex;
    margin-top: 15px;
    position: relative;
    justify-content: space-between;
    gap: var(--list-gap);

    .progress {
      position: absolute !important;
      width: 100%;
      left: 0;
      height: 16px;
      bottom: 35px;
      border: 2px solid var(--progress-bg);
      border-radius: 16px;
      overflow: hidden;
    }

    .item {
      width: 160px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      flex-shrink: 0;

      &:last-of-type {
        .progress {
          width: 100%;
        }
      }

      .circle {
        width: 32px;
        height: 32px;
        background: var(--circle-background);
        border-radius: 100%;
        border: 2px solid var(--progress-bg);
        margin-top: 20px;
        position: relative;

        &:after {
          content: "";
          position: absolute;
          width: 32.5px;
          background: var(--progress-bg);
          height: 12px;
          top: 8px;
          left: -2px;
        }
      }

      .number {
        font-size: 18px;
        font-weight: bold;
        color: var(--circle-background);
      }

      .card {
        box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.08);
        cursor: pointer;
        overflow: hidden;

        .thumb {
          width: 100%;
          height: 140px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          overflow: hidden;

          &-number {
            position: absolute;
            bottom: 5px;
            right: 10px;
            font-size: 14px;
            color: var(--text-color);
            font-weight: bold;
          }

          img {
            max-height: 95px;
            max-width: 95px;
            transition: all 0.24s ease;
          }
        }

        .info-area {
          width: 100%;
          padding: 10px;

          .gifts {
            display: flex;
            margin: 0 auto;
            overflow: auto;
            max-width: 100%;
            white-space: nowrap;
            color: var(--text-color);
            flex-wrap: nowrap;
            min-height: 40px;
            padding-bottom: 10px;

            .icon {
              width: 30px;
              height: 30px;
            }

            .pack {
              font-size: 14px;

              &:first-of-type {
                margin: 0 auto;
              }
            }

            &::-webkit-scrollbar {
              height: 0;
            }
          }

          .handle {
            line-height: 46px;
            width: 100%;
            color: var(--button-text-color);

            span {
              text-align: center;
              width: 100%;
              display: block;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 20px;
              font-weight: bold;
            }

            .get-text {
              color: var(--get-text-color);
            }

            .disabled-text {
              color: var(--disabled-text-color);
            }
          }
        }
      }

      &.is-active {
        div.circle {
          background: var(--progress-inner-color);

          &:after {
            content: "";
            background: var(--progress-inner-color);
          }
        }

        .number {
          color: var(--text-color);
        }
      }
    }

    &:first-of-type {
      margin-top: 20px;
    }
  }

  &.is-mobile {
    .group-list {
      padding: 0 5px;

      .list {
        margin-top: 10px;
        gap: 10px;

        .progress {
          width: 100%;
          height: 10px;
          bottom: 32px;
          left: 0;
        }

        .item {
          width: 100px;

          .card {
            .info-area {
              .gifts {
                min-height: 30px;

                .icon {
                  width: 20px;
                  height: 20px;
                }

                .pack {
                  font-size: 12px;
                }
              }
            }
          }

          .thumb {
            height: 84px;

            &-number {
              font-size: 12px;
            }

            img {
              max-width: 50px;
              max-height: 50px;
            }
          }

          .circle {
            height: 18px;
            width: 18px;
            border: 2px solid var(--progress-bg);
            margin-bottom: 5px;
            margin-top: 10px;

            &:after {
              width: 18.5px;
              height: 6px;
              top: 5px;
              left: -2px;
            }
          }

          .number {
            font-size: 16px;
          }

          .info-area {
            padding: 5px;

            .handle {
              line-height: 24px;

              span {
                font-size: 12px;
              }
            }
          }
        }

        &:first-of-type {
          margin-top: 20px;
        }
      }
    }
  }

  &.is-mobile.mobile-col-3 {
    .group-list {
      .list {
        width: 100%;
        justify-content: space-between;
        gap: 0;
      }
    }
  }

  &.is-mobile.mobile-col-4 {
    .group-list {
      .list {
        width: 100%;
        justify-content: space-between;
        gap: 0;
        margin-top: 5px;

        &:first-of-type {
          margin-top: 20px;
        }

        .item {
          width: 75px;

          .thumb {
            height: 62px;

            img {
              max-width: 40px;
              height: 40px;
            }
          }

          .info-area {
            padding: 5px;

            .gifts {
              padding-bottom: 5px;
            }
          }

          .circle {
            width: 12px;
            height: 12px;
            border: 1px solid var(--progress-bg);
            margin-bottom: 0;

            &:after {
              height: 2px;
            }
          }

          .circle+.number {
            font-size: 14px;
          }
        }
      }

      .progress {
        height: 4px;
        border: 1px solid var(--progress-bg);
        bottom: 24px;
      }
    }
  }
}
</style>
